/* This file was generated automatically. Do not edit manually. */

export enum AgeingTypes {
    LessThan30 = 'LessThan30',
    UpTo60 = 'UpTo60',
    UpTo90 = 'UpTo90',
    Plus90 = 'Plus90',
}
